// Import the necessary function from the Redux Toolkit library
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { current } from "@reduxjs/toolkit";
import { getRangeForPagination } from "../../services/ProductsService";
const initialState = {
  categoryID: null,
  isCategoryModal: false,
  categoryId: null,
  categoryName: null,
  searchParams: "",
  searchEffectRun: false,
  priceRangeData: {},
  isLoading: false,
  error: null,
};
export const fetchPricerangeDetails: any = createAsyncThunk(
  "/price-page-range-data",
  async () => {
    const response = await getRangeForPagination();
    return response.data;
  }
);
export const shopSlice = createSlice({
  name: "shopSlice",
  initialState,
  reducers: {
    setCategoryID: (state: any, action: any) => {
      state.categoryID = action.payload;
    },
    setIsCategoryModal: (state: any, action: any) => {
      state.isCategoryModal = action.payload;
    },
    setCategoryId: (state: any, action: any) => {
      state.categoryId = action.payload;
    },
    setCategoryName: (state: any, action: any) => {
      state.categoryName = action.payload;
    },
    setSearchParams: (state: any, action: any) => {
      state.searchParams = action.payload;
      state.searchEffectRun = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPricerangeDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPricerangeDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        let res ={
            ...action.payload,
            min_price_amount: Math.ceil(action?.payload?.min_price_amount),
            max_price_amount : Math.ceil(action?.payload?.max_price_amount)
        }
        state.priceRangeData = res;
      })
      .addCase(fetchPricerangeDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to fetch cart details";
        console.error("Fetch cart details failed:", action.error);
      });
  },
});

// Export the action creator generated by createSlice
export const {
  setCategoryID,
  setIsCategoryModal,
  setCategoryId,
  setCategoryName,
  setSearchParams,
}: any = shopSlice.actions;

// Export the reducer function generated by createSlice
export default shopSlice.reducer;
